'use client'

import { createPortal } from 'react-dom'
import { PropsWithChildren, useLayoutEffect, useState } from 'react'
import { createWrapperAndAppendToBody } from '@/global/utils/create-wrapper-and-append-to-body'

export interface PortalProps {
  wrapperId: string
}

export const Portal = ({
  children,
  wrapperId = 'portal-wrapper'
}: PropsWithChildren<PortalProps>) => {
  const [wrapperElement, setWrapperElement] = useState<HTMLElement | null>(null)

  useLayoutEffect(() => {
    let element = document.getElementById(wrapperId)
    let systemCreated = false

    if (!element) {
      systemCreated = true
      element = createWrapperAndAppendToBody(wrapperId)
    }

    setWrapperElement(element)

    return () => {
      if (systemCreated && element?.parentNode) {
        element.parentNode.removeChild(element)
      }
    }
  }, [wrapperId])

  if (!wrapperElement) return null

  return createPortal(children, wrapperElement)
}
